"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FileDownLoadConstants = exports.TEXT_SUCCESSFUL = exports.TEXT_SUCCESS = exports.FILE_DOWNLOAD_RESOLUTION_TABLET = exports.FILE_DOWNLOAD_RESOLUTION_MOBILE = exports.FILE_DOWNLOAD_TRECIENTOS = exports.FILE_DOWNLOAD_DOSCIENTOS = exports.FILE_DOWNLOAD_CIEN = exports.FILE_DOWNLOAD_CUATRO = exports.FILE_DOWNLOAD_UNO = exports.FILE_DOWNLOAD_CERO = exports.FILE_DOWNLOAD_SUCCESS_MESSAGE_TITLE = exports.FILE_DOWNLOAD_ERROR_MESSAGE_SUBTITLE = exports.FILE_DOWNLOAD_ERROR_MESSAGE_TITTLE = exports.FILE_DOWNLOAD_ERROR_MESSAGE = exports.FILE_DOWNLOAD_LOADER_2 = exports.FILE_DOWNLOAD_ACCORDION_ACTIVE = exports.FILE_DOWNLOAD_ACCORDION_SUBTITLE = exports.FILE_DOWNLOAD_ACCORDION_TITLE = exports.FILE_DOWNLOAD_ACCORDION_TYPE = exports.FILE_DOWNLOAD_PROGRESS_GREEN = exports.FILE_DOWNLOAD_PROGRESS_ORANGE = exports.FILE_DOWNLOAD_PROGRESS_YELLOW = exports.FILE_DOWNLOAD_PROGRESS_CONTAINER = exports.FILE_DOWNLOAD_ICON = exports.FILE_DOWNLOAD_LOADER = exports.FILE_DOWNLOAD_ROWSCROLL = exports.FILE_DOWNLOAD_ROWSCONTAINER = exports.FILE_DOWNLOAD_SUCCESS = exports.FILE_DOWNLOAD_ERROR = exports.FILE_DOWNLOAD_ROW = exports.FILE_DOWNLOAD_CONTAINER = exports.FILE_DOWNLOAD_ACCORDION = exports.FILE_DOWNLOAD = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
exports.FILE_DOWNLOAD = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-file-download");
exports.FILE_DOWNLOAD_ACCORDION = exports.FILE_DOWNLOAD + '-accordion';
exports.FILE_DOWNLOAD_CONTAINER = exports.FILE_DOWNLOAD + '-container';
exports.FILE_DOWNLOAD_ROW = exports.FILE_DOWNLOAD + '-row';
exports.FILE_DOWNLOAD_ERROR = exports.FILE_DOWNLOAD + '-error';
exports.FILE_DOWNLOAD_SUCCESS = exports.FILE_DOWNLOAD + '-success';
exports.FILE_DOWNLOAD_ROWSCONTAINER = exports.FILE_DOWNLOAD + '-rowsContainer';
exports.FILE_DOWNLOAD_ROWSCROLL = exports.FILE_DOWNLOAD + '-rowScroll';
exports.FILE_DOWNLOAD_LOADER = exports.FILE_DOWNLOAD + '-loader';
exports.FILE_DOWNLOAD_ICON = exports.FILE_DOWNLOAD + '-icon';
exports.FILE_DOWNLOAD_PROGRESS_CONTAINER = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-progress-container");
exports.FILE_DOWNLOAD_PROGRESS_YELLOW = exports.FILE_DOWNLOAD_PROGRESS_CONTAINER;
exports.FILE_DOWNLOAD_PROGRESS_ORANGE = exports.FILE_DOWNLOAD_PROGRESS_CONTAINER + '-orange';
exports.FILE_DOWNLOAD_PROGRESS_GREEN = exports.FILE_DOWNLOAD_PROGRESS_CONTAINER + '-green';
exports.FILE_DOWNLOAD_ACCORDION_TYPE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-basic");
exports.FILE_DOWNLOAD_ACCORDION_TITLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-accordion-title");
exports.FILE_DOWNLOAD_ACCORDION_SUBTITLE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-file-download-accordion-subtitle");
exports.FILE_DOWNLOAD_ACCORDION_ACTIVE = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-active");
exports.FILE_DOWNLOAD_LOADER_2 = "".concat(common_constants_1.BcCommonConstants.PREFIX_LIB, "-loader");
exports.FILE_DOWNLOAD_ERROR_MESSAGE = "Error al generar el archivo";
exports.FILE_DOWNLOAD_ERROR_MESSAGE_TITTLE = "Error en la descarga";
exports.FILE_DOWNLOAD_ERROR_MESSAGE_SUBTITLE = "Ocurri\u00F3 un error en la generaci\u00F3n de un archivo";
exports.FILE_DOWNLOAD_SUCCESS_MESSAGE_TITLE = "Descarga Completada";
exports.FILE_DOWNLOAD_CERO = 0;
exports.FILE_DOWNLOAD_UNO = 1;
exports.FILE_DOWNLOAD_CUATRO = 4;
exports.FILE_DOWNLOAD_CIEN = 100;
exports.FILE_DOWNLOAD_DOSCIENTOS = 200;
exports.FILE_DOWNLOAD_TRECIENTOS = 300;
exports.FILE_DOWNLOAD_RESOLUTION_MOBILE = 575;
exports.FILE_DOWNLOAD_RESOLUTION_TABLET = 768;
exports.TEXT_SUCCESS = 'success';
exports.TEXT_SUCCESSFUL = 'successful';
var FileDownLoadConstants = (function () {
    function FileDownLoadConstants() {
    }
    var _a;
    _a = FileDownLoadConstants;
    FileDownLoadConstants.MAX_DOWNLOAD_LENGHT = 5;
    FileDownLoadConstants.RETRY = 'Reintentar';
    FileDownLoadConstants.MOBILE_DEVICE = 'mobile';
    FileDownLoadConstants.TABLET_DEVICE = 'tablet';
    FileDownLoadConstants.DOWNLOAD_FILE_STATUS_INIT = 'init';
    FileDownLoadConstants.DOWNLOAD_FILE_STATUS_SUCCESS = 'success';
    FileDownLoadConstants.DOWNLOAD_FILE_STATUS_ERROR = 'error';
    FileDownLoadConstants.DOWNLOAD_FILE_STATUS_PROGRESS = 'progress';
    FileDownLoadConstants.DONWLOAD_FILE_DATA = 'data';
    FileDownLoadConstants.DONWLOAD_FILE_DATA_MOBILE = _a.DONWLOAD_FILE_DATA + '-mobile';
    FileDownLoadConstants.DONWLOAD_FILE_DATA_TABLET = _a.DONWLOAD_FILE_DATA + '-tablet';
    FileDownLoadConstants.BC_ICON_CLASS = 'bc-icon';
    FileDownLoadConstants.BC_ICON_BUTTON_CLASS = _a.BC_ICON_CLASS + '-button';
    FileDownLoadConstants.BC_ICON_BUTTON_DOWNLOAD_CLASS = _a.BC_ICON_CLASS + '-download';
    FileDownLoadConstants.BC_TAG_BUTTON_CLASS = 'tag-button';
    FileDownLoadConstants.DOWNLOAD_DOCUMENT = 'download-document';
    FileDownLoadConstants.SUCCESSFUL_CLASS = 'successful';
    FileDownLoadConstants.ALERT_CLASS = 'alert';
    FileDownLoadConstants.PRELOADER_CLASS = 'bc-preloader';
    FileDownLoadConstants.PROGRESS_BAR_CLASS = 'bc-progress-bar';
    FileDownLoadConstants.PROGRESS_TEXT_CLASS = 'progress-text';
    FileDownLoadConstants.SAVE_FILE_CLASS = 'save-file';
    FileDownLoadConstants.FILE_DOWNLOAD_CLASS = 'file-download';
    FileDownLoadConstants.FILE_DOWNLOAD_ROW_CLASS = _a.FILE_DOWNLOAD_CLASS + '-row';
    FileDownLoadConstants.FILE_DOWNLOAD_ROWSCROLL_HEIGHT = 400;
    FileDownLoadConstants.FILE_DOWNLOAD_ROWSCROLL_OVERFLOW = 'auto';
    FileDownLoadConstants.FILE_DOWNLOAD_FILENAME_CLASS = 'bc-file-download-filename';
    FileDownLoadConstants.FILE_DOWNLOAD_SUCCESS_COLOR = 'green';
    FileDownLoadConstants.FILE_DOWNLOAD_ERROR_COLOR = 'red';
    FileDownLoadConstants.FILE_DOWNLOAD_PROGRESS_INIT = 5;
    return FileDownLoadConstants;
}());
exports.FileDownLoadConstants = FileDownLoadConstants;
